/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const buildInternals = (data: any) =>
  data &&
  data.map((obj: any) => ({
    id: `${obj.first_name} ${obj.last_name}`,
    name: `${obj.first_name} ${obj.last_name}`,
    email: `${obj.email}`,
  }));
